<template>
    <div class="row ml-0 mr-0">
        <div class="col-12 col-md-12 p-0 seat-preview">
            <span class="float-left">
                Số ghế:
            </span>
            <b v-if="!seatsPreview.length" class="float-right">
                <span class="seat-template-seat-code">
                    Quý khách vui lòng chọn ít nhất một chỗ ngồi.
                </span>
            </b>
            <b v-if="seatsPreview.length" class="float-right">
                <span class="seat-template-seat-code">
                    {{seatsPreview.join(', ')}}
                </span>
            </b>
        </div>
        <div class="col-12 col-md-12 p-0">
            <span class="float-left">Tổng tiền:</span>
            <div class="float-right">
<!--                <span class="seat-template-old-total-fare"-->
<!--                      style="font-size: 14px; text-decoration: line-through; margin-right: 10px;">-->
<!--                </span>-->
                <h4 class="seat-template-total-fare price">{{price.toLocaleString('us')}}</h4>
                <small class="unit-price">đ
                </small>
            </div>
        </div>
    </div>
</template>

<script>
    import {MixinHelper} from "../../../shared/services";

    export default {
        name: "SeatPreview",
        mixins: [MixinHelper],
        props: {
            seats: {
                type: Array,
                default: function () {
                    return [];
                }
            },
            price: {
                type: Number,
                default: 0
            }
        },
        computed: {
            seatsPreview() {
                const self = this;
                return this.seats.map(function(s) {
                    return self.getProp(s, 'p_row', '') + '.' + self.getProp(s, 'p_col', '');
                });
            }
        }
    }
</script>

<style scoped>

    .seat-preview{
        min-height: 25px;
    }
    .unit-price {
        vertical-align: top; text-decoration: underline;color:red !important;
    }
    .seat-template-total-fare {
        display: inline-block !important;
    }
    .price {
        font-size: 20px;
        color: red
    }
    .seat-template-seat-code {
        font-size: 13px;
    }

</style>
